import { AppModel } from '../../constants/api';
import { useStore } from '../../store/appStores';

export const useExtension = (extensionKey) => {
  const enabledExtensions = useStore(AppModel.APP_EXTENSION);

  return enabledExtensions.find((x) => x.key === extensionKey);
};
